<template>
  <form enctype="multipart/form-data" class="subscribe-form">
    <input type="hidden" name="TYPE_FORM" value="subscribe">
    <input type="hidden" name="Theme" :value="themeValue">
    <input type="hidden" name="PORTFOLIO" value="Almost Perfect">

    <div class="subscribe-form__value">
      <input type="email" name="Email" id="email" placeholder="E-mail" class="subscribe-form__input input-email" required>
      <button type="submit" class="button button_white">
        Subscribe
        <IconArrow/>
      </button>
    </div>

    <div class="subscribe-form__agree">
      <div class="checkbox-input">
        <input type="checkbox" name="AGREEMENT" :id="checkboxId" class="checkbox">
        <label :for="checkboxId">
          I want to receive exclusive content from Almost&nbsp;Perfect: insider&nbsp;guides and personalized tips for my store.
        </label>
      </div>
    </div>
  </form>
</template>

<style lang="scss">
.subscribe-form {
  .subscribe-msg {
    color:#fff;
    opacity:.5;
    font-size:12px;
    margin:1.5rem 0 0;
  }

  &__value {
    display:flex;
    gap:10px;
    position:relative;
  }

  &__input {
    height:3.5rem;
    padding:0 1rem;
    border-radius:1rem;
    background: rgba(244, 244, 244, 0.08);
    font-weight:500;
    color:#fff;
    font-size:1rem;
    transition:var(--transition);
    border:1px solid transparent;
    width: 100%;
    box-sizing:border-box;
    font-family:var(--font-family);
    outline:none;

    @include md {
      height:3rem;
    }

    &:focus {
      background: rgba(244, 244, 244, 0.1);
    }

    &::placeholder {
      color:rgba(255,255,255,.5);
    }
  }

  &__agree {
    position:relative;
    margin:1.5rem 0 0;

    @include md {
      margin-top:1rem;
    }
  }

  .button {
    flex:none;

    @include md {
      width:initial;
    }
  }
}
</style>

<script setup>
import { onMounted, computed } from 'vue'
import JustValidate from 'just-validate'
import IconArrow from '@/components/icons/IconArrow.vue'

const props = defineProps({
  theme: {
    type: String,
    default: ''
  },
  id: {
    type: Number,
    default: 0
  }
})

const themeValue = computed(() => props.theme ? props.theme : 'None')
const checkboxId = computed(() => `subscribe-agree-${props.id}`)

onMounted(() => {
  const forms = document.querySelectorAll('.subscribe-form')

  forms.forEach((form, index) => {
    const emailInput = form.querySelector('.input-email')
    const checkbox = form.querySelector('.checkbox')

    if (!emailInput || !checkbox) return

    let msgEl = form.querySelector('.subscribe-msg')
    if (!msgEl) {
      msgEl = document.createElement('div')
      msgEl.className = 'subscribe-msg'
      form.appendChild(msgEl)
    }

    const validation = new JustValidate(form)

    validation
        .addField(emailInput, [
          { rule: 'required', value: true, errorMessage: 'Please enter your email' },
          { rule: 'email', value: true, errorMessage: 'Email format is invalid' }
        ])
        .addField(checkbox, [
          { rule: 'required', value: true, errorMessage: 'You must agree to Terms & Privacy Policy' }
        ])
        .onSuccess((event) => {
          let formData = new FormData(event.target)
          let xhr = new XMLHttpRequest()

          form.classList.add('loading')

          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                msgEl.textContent = 'Thank you for subscribing!'
                event.target.reset()
              } else {
                msgEl.textContent = 'Something went wrong. Please try again.'
              }
              form.classList.remove('loading')
            }
          }

          xhr.open('POST', 'https://creativecommercelabs.com/zendesk/subscribe.php', true)
          xhr.send(formData)
        })
  })
})
</script>
